<template>
  <footer class="border-t border-black/5 bg-white/95 backdrop-blur-xl dark:border-white/10 dark:bg-[#020617]/95">
    <UiContainer>
      <div class="py-10 lg:py-12">
        <div class="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div class="max-w-sm space-y-4">
            <div class="flex items-center gap-2">
              <div
                class="flex h-9 w-9 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 via-sky-400 to-cyan-400 shadow-[0_8px_22px_rgba(56,189,248,0.55)] ring-1 ring-sky-500/40"
              >
                <img :src="logo" alt="NexGridCo" class="h-7 w-7 rounded-xl object-cover" />
              </div>
              <span class="text-sm font-semibold tracking-[0.22em] uppercase text-zinc-800 dark:text-zinc-100">
                NexGridCo
              </span>
            </div>

            <p class="text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">
              Generate unique fonts with AI from a text description. Built for modern teams and meticulous designers.
            </p>

            <div
              class="inline-flex items-center gap-2 rounded-full border border-zinc-200/80 bg-white/80 px-3 py-1.5 text-[11px] font-medium uppercase tracking-[0.18em] text-zinc-500 shadow-sm dark:border-zinc-700/80 dark:bg-black/50 dark:text-zinc-300"
            >
              <span class="h-1.5 w-1.5 rounded-full bg-emerald-400"></span>
              Live for designers
            </div>
          </div>

          <div class="grid flex-1 gap-8 sm:grid-cols-3">
            <div class="space-y-3">
              <p class="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
                Product
              </p>
              <ul class="space-y-2 text-sm text-zinc-600 dark:text-zinc-300">
                <li>
                  <router-link
                    to="/pricing"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Pricing
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="space-y-3">
              <p class="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
                Support
              </p>
              <ul class="space-y-2 text-sm text-zinc-600 dark:text-zinc-300">
                <li>
                  <router-link
                    to="/docs"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Documentation
                  </router-link>
                </li>
                <li>
                  <a
                    href="mailto:contact@nexgridco.com"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div class="space-y-3">
              <p class="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
                Legal
              </p>
              <ul class="space-y-2 text-sm text-zinc-600 dark:text-zinc-300">
                <li>
                  <router-link
                    :to="{ name: 'terms' }"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Terms of Use
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'privacy' }"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Privacy Policy
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'dpa' }"
                    class="transition hover:text-zinc-900 dark:hover:text-white"
                  >
                    Data Protection Agreement
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="mt-8 border-t border-zinc-200/70 pt-5 dark:border-zinc-800">
          <div class="flex flex-col items-center justify-between gap-3 text-xs text-zinc-500 dark:text-zinc-400 sm:flex-row">
            <span>© {{ year }} NexGridCo. All rights reserved.</span>
            <span class="text-[11px] tracking-[0.16em] uppercase">
              Crafted with color, type and intent.
            </span>
          </div>
        </div>
      </div>
    </UiContainer>
  </footer>
</template>

<script setup>
import UiContainer from '../ui/Container.vue'
import logo from '@/assets/logo.png'

const year = new Date().getFullYear()
</script>
